import { useEffect } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { toast } from "sonner";
import { MainNavbar } from "@/components/layout/MainNavbar";
import { PublicFooter } from "@/components/layout/PublicFooter";
import { PublicBottomNav } from "@/components/layout/PublicBottomNav";
import { useAuth } from "@/context/AuthContext";
import { dictionary } from "@/i18n/translations";
import { scrollPageToTop, scrollToElementById } from "@/lib/scroll";

export const PublicLayout = () => {
  const { lang } = useParams();
  const location = useLocation();
  const copy = dictionary[lang];
  const { isAuthenticated, logout } = useAuth();

  useEffect(() => {
    const scrollTarget = location.state?.scrollTarget;
    if (scrollTarget === "map") {
      const timer = window.setTimeout(() => {
        scrollToElementById("map");
      }, 120);

      return () => window.clearTimeout(timer);
    }

    if (scrollTarget === "top") {
      const timer = window.setTimeout(() => {
        scrollPageToTop();
      }, 60);

      return () => window.clearTimeout(timer);
    }

    if (location.hash === "#map") {
      const timer = window.setTimeout(() => {
        scrollToElementById("map");
      }, 120);

      return () => window.clearTimeout(timer);
    }

    const timer = window.setTimeout(() => {
      scrollPageToTop(0);
    }, 0);

    return () => window.clearTimeout(timer);
  }, [location.hash, location.pathname, location.state]);

  return (
    <div className="public-layout-shell" data-testid="public-layout-shell">
      <MainNavbar
        lang={lang}
        labels={copy.nav}
        isAuthenticated={isAuthenticated}
        onLogout={() => {
          logout();
          toast.success(copy.auth.logoutSuccess);
        }}
      />

      <div className="public-layout-content" data-testid="public-layout-content">
        <Outlet />
      </div>

      <PublicFooter lang={lang} copy={copy} />
      <PublicBottomNav lang={lang} copy={copy} />
    </div>
  );
};
